import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompareserviceService } from '../compareservice.service';
import { MatTableDataSource } from '@angular/material/table';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { MatDialog } from '@angular/material/dialog';
import { InfoPopupComponent } from 'src/app/shared/components/info-popup/info-popup.component';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
import { TaskListPopupComponent } from 'src/app/shared/components/task-list-popup/task-list-popup.component';

@Component({
  selector: 'app-workbook-csv',
  templateUrl: './workbook-csv.component.html',
  styleUrls: ['./workbook-csv.component.scss']
})
export class WorkbookCsvComponent implements OnInit {
  public batchKey: string = null;
  public loader: boolean;
  public batchStatus: any;
  public createWorkbookData: any = [];
  public compareWorkbookData: any = [];
  public dataValue: [] = [];
  public dateFormat: any;
  dataSourceWorkBookExtract: any = new MatTableDataSource();
  displayedColumns: string[] = ['batch_key', 'source_type', 'date', 'workbook_status', 'action'];
  filterSelectObj = [];
  public workbookNewBtnDisable: boolean = true;
  public searchNewBtnDisable: boolean = true;
  items = [];
  pageOfItems: Array<any>;
  loadToCloudData: any = [];
  filteredValue;
  filterValues = {};
  public searchText;
  public hideme: number;
  public searchText1;
  isTrainStopUrl: boolean;
  legacyBatchKeys: any = [];
  extractFromCloudData: any = [];
  extractionBatchKeys: any = [];
  projectId: string;
  queryParams: any;
  isChecked: boolean = false;
  downloadDropdown: boolean = false;
  emptyTable: boolean = false;
  public refresh: boolean = true;
  selected: any = [];
  failedToFetchExtracts: boolean = false;
  noCSVExtractsCreated: boolean = false;
  pageIndex = 0;
  size = 5;
  p: any = 1;
  tableData: any;
  taskLevelData: any = [];
  constructor(private router: Router,
    public dialog: MatDialog,
    private celService: CompareserviceService,
    private _data: DataService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private notification: NotificationService) {
    this.isTrainStopUrl = this.celService.getisTrainStopUrl();
    if (this.isTrainStopUrl) {
      // let obj={
      //   PROJ_ID: sessionStorage.getItem('projId'),
      //   USER_ID: sessionStorage.getItem('userId'),
      // }
      const obj = JSON.parse(sessionStorage.getItem('queryParams'));
      this.queryParams = obj;
    }
    this.filterSelectObj = [
      {
        name: 'Status',
        columnProp: 'workbook_status',
        options: []
      }
    ];

  }


  ngOnInit(): void {
    const prjid = this._data.projectID;
    if (prjid == null || prjid == undefined) {
      this.router.navigate([""], { relativeTo: this.route });
    } else {
      this.onRefresh();
      this.getWorkbookExtractBatchkeys();
      this.getSelectedBatchTasks();
      this.dataSourceWorkBookExtract.filterPredicate = this.createFilterForWorkbookExtract();
    }
  }


  getWorkbookExtractBatchkeys() {
    this.emptyTable = false;
    this.loader = true;
    this.refresh = false;
    this.celService.getWorkbookExtractBatchkeys().subscribe((res) => {
      this.refresh = true;
      if (res?.Result === "SUCCESS" && res.Workbook_Status !== undefined) {
        this.searchNewBtnDisable = false;
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        !res.Workbook_Status.length ? this.noCSVExtractsCreated = true : this.noCSVExtractsCreated = false;
        this.extractionBatchKeys = this.getDistinctWookBooks(res.Workbook_Status);
        this.dataSourceWorkBookExtract.data = this.extractionBatchKeys;
        this.tableData = this.dataSourceWorkBookExtract.data;
        this.failedToFetchExtracts = false;
        this.filterSelectObj.filter((o) => {
          o.options = this.getFilterObject(this.extractionBatchKeys, o.columnProp);
          o.options.splice(0, 0, "None");
        });
        this.sortDataForWorkbook();
      } else {
        this.failedToFetchExtracts = true;
      }
    }, error => {
      this.refresh = true;
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
      this.failedToFetchExtracts = true;
      this.notification.showError('Something went wrong!');
    });
  }

  getFilterObject(fullObj, key) {
    const uniqChk = [];
    fullObj.filter((obj) => {
      if (!uniqChk.includes(obj[key])) {
        uniqChk.push(obj[key]);
      }
      return obj;
    });
    return uniqChk;
  }

  filterChange(filter, event, indexVal) {
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    this.filterValues[filter.columnProp] = event.target.value.trim().toLowerCase();
    this.dataSourceWorkBookExtract.filter = JSON.stringify(this.filterValues);
    this.tableData = this.dataSourceWorkBookExtract.filteredData;

  }

  paginate(event: any) {
    this.pageIndex = event;
    this.tableData = this.dataSourceWorkBookExtract.filteredData.slice(event * this.size - this.size, event * this.size);
  }

  getDistinctBatchKeys(res) {
    const distinctBatchKeys = res.reduce((obj, curr) => {
      if (!obj[curr.batch_key]) {
        obj[curr.batch_key] = curr;
      }
      return obj;
    }, Object.create(null));
    return Object.values(distinctBatchKeys);
  }

  getDistinctWookBooks(res) {
    const distinctBatchKeys = res
      .filter(e => e.extract_status !== 'New')
      .reduce((obj, curr) => {

        let success_count = 0;
        const total_count = 1;
        let ErrorModule;
        let success_path = '';
        const success_files = [];
        if (curr.output_file_path && (curr.output_file_path).includes('\\OUT\\')) {
          success_count++;
          success_path = curr.output_file_path;
          success_files.push(curr.output_file_path);
        } else {
          const output_file_path = curr.output_file_path;
          ErrorModule = {
            "application": "Error",
            "fileList": [curr.output_file_path],
            "output_file_path": output_file_path,
            "success_count": 0,
            "total_count": 0
          };
        }
        const currModule = {
          "application": curr.application,
          "fileList": success_files,
          "output_file_path": success_path,
          "success_count": success_count,
          "total_count": total_count
        };
        const item = {
          "batch_key": curr.batch_key,
          "creation_date": curr.creation_date,
          "workbook_status": curr.extract_status,
          "source_type": curr.source_type,
          module: []
        };
        if (!obj[curr.batch_key]) {
          obj[curr.batch_key] = item;
          obj[curr.batch_key].module.push(currModule);
          //if error module then push it
          if (ErrorModule) {
            obj[curr.batch_key].module.push(ErrorModule);
          }
        } else {
          //same batch && new module
          if (!obj[curr.batch_key].module
            .find(e => e.application === curr.application)) {
            if (obj[curr.batch_key].module.length &&
              obj[curr.batch_key].module.find(e => e.application === "Error")) {
              obj[curr.batch_key].module.splice(
                obj[curr.batch_key].module
                  .findIndex((e) => e.application === "Error"), 0, currModule);
            } else {
              obj[curr.batch_key].module.push(currModule);
            }
          } else {
            //same batch && same module
            obj[curr.batch_key].module.map(e => {
              if (e.application === curr.application) {

                e.total_count += 1;

                if (curr.output_file_path
                  && (curr.output_file_path).includes('\\OUT\\')) {
                  e.success_count += 1;
                  curr.output_file_path = success_path;
                  e.output_file_path = curr.output_file_path;

                  if (!(e.fileList).includes(curr.output_file_path)) {
                    e.fileList.push(curr.output_file_path);
                  }
                }
              }
              return e;
            });
          }

          //same batch push error module if not available
          if (ErrorModule && !obj[curr.batch_key].module
            .find(e => e.application === 'Error')) {
            obj[curr.batch_key].module.push(ErrorModule);
          }
        }
        obj[curr.batch_key].downloadAll = false;
        obj[curr.batch_key].module.map(e => {
          // if(e.success_count > 0 && obj[curr.batch_key].module.length > 1) {
          if(e.success_count > 0 ) {
            if(obj[curr.batch_key].module.length > 1) {
              obj[curr.batch_key].downloadAll = true;
          }
        }
        });
        return obj;
      }, Object.create(null));
    return Object.values(distinctBatchKeys);
  }



  sortDataForWorkbook() {
    return this.extractionBatchKeys.sort((a, b) => {
      return <any>new Date(b.creation_date) - <any>new Date(a.creation_date);
    });
  }

  onRefresh() {
    this.extractionBatchKeys.length = 0;
    this.refresh = false;
    this.emptyTable = false;
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    this.filterValues = {};
    this.searchText = undefined;
    this.maskPage();
    this.filterSelectObj = [
      {
        name: 'Status',
        columnProp: 'workbook_status',
        options: []
      }
    ];
    this.dataSourceWorkBookExtract = new MatTableDataSource();
    this.dataSourceWorkBookExtract.filterPredicate = this.createFilterForWorkbookExtract();
    this.getWorkbookExtractBatchkeys();
    this.getSelectedBatchTasks();

  }


  maskPage() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
  }

  searchForWorkbook(value: string): void {
    if (value == null || value == undefined) {
      return;
    }
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    const searchText1 = value.toUpperCase();
    this.dataSourceWorkBookExtract.data = this.extractionBatchKeys.filter((val) => val.batch_key.toUpperCase().includes(searchText1));
    this.tableData = this.dataSourceWorkBookExtract.filteredData;

    if (this.extractionBatchKeys.some(item => item.batch_key === value) || value == "") {
      this.emptyTable = false;
      this.filterValues = {};
      this.searchText1 = undefined;
      this.filterSelectObj = [
        {
          name: 'Status',
          columnProp: 'workbook_status',
          options: []
        }
      ];
      this.filterSelectObj.filter((o) => {
        o.options = this.getFilterObject(this.extractionBatchKeys, o.columnProp);
        o.options.splice(0, 0, "None");
      });
      this.dataSourceWorkBookExtract = new MatTableDataSource();
      this.dataSourceWorkBookExtract.filterPredicate = this.createFilterForWorkbookExtract();
      this.dataSourceWorkBookExtract.data = this.extractionBatchKeys.filter((val) => val.batch_key.toUpperCase().includes(searchText1));
      this.dataSourceWorkBookExtract.filter = JSON.stringify(this.filterValues);
      this.tableData = this.dataSourceWorkBookExtract.filteredData;
    } else {
      this.emptyTable = true;
    }


  }



  onSubmit() {
    const body = this.onConfigSubmit();
    this.celService.onWorbookSubmit(body).subscribe((res) => {
      if (res.Result === 'SUCCESS') {
        this.batchKey = res.Batch_Key;
        this.batchStatus = res.Batch_Status;
        this.celService.batchKey = this.batchKey;
        this.celService.batchStatus = this.batchStatus;
      }
      if (res.Batch_Key) {
        const dialogRef = this.dialog.open(InfoPopupComponent, {
          width: "917px",
          height: "220px",
          data: {
            type: 'Task Status',
            mess: `Batch Key ${res.Batch_Key} :<b> New</b>`,
          }
        });
        dialogRef.afterClosed().subscribe((result) => {
          if ((result = "ok")) {
            this.router.navigate(["../workbookSubmit"], { relativeTo: this.route });
          }
        });
      } else {
        alert(res.Result);

        this.router.navigate(["../workbookSubmit"], { relativeTo: this.route });
      }
    },
      (error) => {
        this.notification.showError('Something went wrong!');
      });
  }

  onConfigSubmit() {
    const body = {
      batchkey: this.celService.batchKey ? this.celService.batchKey : "",
      projectname: this.celService.projId,
      requestedby: this.celService.requestedBy,
      filesharepath: this.celService.getfileSharePath(),
      requesttype: "EXTRACT"
    };
    return body;
  }

  getLineItems(configData) {
    const data = [];
    configData?.forEach((element) => {
      if (element.batch_key && element.extract_status) {
        const trackObj = {
          batchkey: element.batch_key,

        };
        data.push(trackObj);
      }
    });
    return data;
  }



  createFilterForWorkbookExtract() {
    const filterFunction = function (data, filter): boolean {
      const searchTerms = JSON.parse(filter);
      let isFilterSet = false;
      for (const col in searchTerms) {
        if (searchTerms[col].toString() !== '' && searchTerms[col].toString().toLowerCase() !== 'none') {
          isFilterSet = true;
        } else {
          delete searchTerms[col];
        }
      }

      const nameSearch = () => {
        let found = false;
        if (isFilterSet) {
          if (data.workbook_status.toLowerCase() == searchTerms.workbook_status) {
            found = true;
          }
          else if ((!searchTerms.workbook_status || searchTerms.workbook_status == "undefined")) {
            found = true;
          }
          return found;
        } else {
          return true;

        }
      };
      return nameSearch();
    }
    return filterFunction;
  }



  downloadFilesForCsvExtract(module, batchKey, downloadInfile=false) {
    let fileList;
    if(Array.isArray(module)) {

      fileList = module.reduce((obj, curr) => {
        // if(curr.application !=='Error' && curr.fileList) {
        if(curr.fileList && curr.fileList.length) {
          obj = obj.concat(curr.fileList);
        }
        return obj;
      },[]);
    } else if (module.fileList) {
      fileList = module.fileList;
    }
    if (fileList && fileList.length > 0) {
      this._data.apiCallInProgress = true;
      document.getElementById("overlay").style.display = "block";
      const body = downloadInfile
        ? {
            filePath: fileList[0].split("OUT")[0]+"IN\\",
            batchKey: batchKey,
          }
        : {
            fileList: fileList,
          };

      this.celService.downloadFilesForCsvExtract(body).subscribe(res => {
        if (res.byteLength === 1176) {
          this.notification.showError("Failed to download extracts");
        } else {
          this.writeContents(res, `${batchKey}_REV_WORKBOOK.zip`);
          this._data.apiCallInProgress = false;
          document.getElementById("overlay").style.display = "none";
          this.hideme = null;
        }
      },
        error => {
          this._data.apiCallInProgress = false;
          document.getElementById("overlay").style.display = "none";
          this.notification.showError("Failed to download extracts");
        });
    } else {
      this.notification.showError("File not found");
    }
  }



  writeContents(content, fileName) {  //contentType
    const a = document.createElement('a');
    const file = new Blob([content]); //, { type: contentType }
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

  onBatchKeyClick(batchKey, element) {
    this.alertPopUp("Task Status", `Batch Key ${batchKey}: <b>${element.workbook_status}</b>`);
  }

  alertPopUp(type, mess) {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        type: type,
        mess: mess
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if ((result = "ok")) {
        dialogRef.close();
      }
    });
  }


  // check if the item are selected
  checked(item) {
    if (this.selected.indexOf(item) !== -1) {
      return true;
    }
  }

  // when checkbox change, add/remove the item from the array
  onChange(checked, item) {
    if (checked) {
      this.selected.push(item);
      this.workbookNewBtnDisable = false;
    } else {
      this.workbookNewBtnDisable = true;
      this.selected.splice(this.selected.indexOf(item), 1);
    }
  }

  onChangePage(pageOfItems: Array<any>) {
    // update current page of items
    this.pageOfItems = pageOfItems;
  }

  getWorkbookPage() {
    this.router.navigate(["/config-workbook"]);
  }

  templatesPage(){
    this.router.navigate(["../workbookTemplates"], { relativeTo: this.route });
  }

  specialCharRemove(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  getDownloadDropdown(i) {
    this.hideme = i;
  }
  autoCloseForDropdownCars(event) {
    var target = event.target;
    if (!target.closest(".download-enhancement")) {
      this.hideme = null;
    }
  }

  getRefresh() {
    this.ngOnInit();
    this.hideme = null;
  }

  searchOnInput1(event) {
    if (event == null || event == undefined || event == '') {
      this.searchForWorkbook('');
    }
  }

  getSelectedBatchTasks() {
    this.maskPage();
    this.celService.getSelectedBatchTasks().subscribe((res) => {
      if (res?.Result === "SUCCESS" && res.Config_Batchkey_Details !== undefined) {
        this.taskLevelData = this.getDistinctBatchKeysNew(res.Config_Batchkey_Details);//res.Batch_key_details;
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";

      } else {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
      }

    }, error => {
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
      this.notification.showError('Something went wrong!');
    });
  }

  getDistinctBatchKeysNew(res) {
    const distinctBatchKeys = res.reduce((obj, curr) => {
      const item = {
        "batch_key": curr.batch_key,
        module: []
      };
      const task_list = [curr.task_name];
      const currModule = {
        "application": curr.application,
        "task_list": task_list,
      };
      if (!obj[curr.batch_key]) {
        obj[curr.batch_key] = item;
        obj[curr.batch_key].module.push(currModule);
      } else {
        //same batch && new module
        if (!obj[curr.batch_key].module
          .find(e => e.application === curr.application)) {
          obj[curr.batch_key].module.push(currModule);
        } else {
          //same batch && same module
          obj[curr.batch_key].module.map(e => {
            if (e.application === curr.application) {
              e.task_list.push(curr.task_name);
            }
          });
        }
      }
      return obj;
    }, Object.create(null));
    return Object.values(distinctBatchKeys);
  }


  tasklistPopup(batchkey) {
    const module = this.taskLevelData.filter(e => e.batch_key == batchkey);
    const dialogRef = this.dialog.open(TaskListPopupComponent, {
      width: "795px",
      height: "470px",
      data: {
        moduleData: { batchkey: batchkey, module: module },
      },
    });
  }
}
